/** @jsx jsx */
import { css, jsx, SerializedStyles } from '@emotion/core';
import {
  Dialog,
  useTheme,
  DialogTitle,
  Typography,
  DialogContent,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import { ICustomTheme } from 'interfaces';

type CustomDialog = {
  children: React.ReactChild;
  open: boolean;
  handleClose: () => void;
  title: string;
};
export const cssCloseButton = (theme: ICustomTheme): SerializedStyles =>
  css({
    color: theme.palette.grey[500],
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  });

const CustomDialog = ({
  title,
  children,
  open,
  handleClose,
}: CustomDialog): JSX.Element => {
  const theme: ICustomTheme = useTheme();

  return (
    <Dialog open={open} onClose={handleClose} fullScreen>
      <DialogTitle css={{ backgroundColor: theme.colors.grey.light5 }}>
        <Typography align="center">{title}</Typography>
        <IconButton
          aria-label="close"
          css={cssCloseButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default CustomDialog;
